import {createFileRoute} from "@tanstack/react-router";

import {routeMessages} from "../../../messages/routes.messages";

import {SettingsPage} from "./-page/settings.page";

export const Route = createFileRoute("/_app/settings/")({
  component: SettingsPage,
  staticData: {
    meta: {
      labelDescriptor: routeMessages.settings,
      nav: {visible: false},
    },
  },
});
